const FEATURE_HELP_URLS = {
  agent_bots: '#hc/agent-bots',
  agents: '#hc/agents',
  audit_logs: '#hc/audit-logs',
  campaigns: '#hc/campaigns',
  canned_responses: '#hc/canned',
  channel_email: '#hc/email',
  channel_facebook: '#hc/fb',
  custom_attributes: '#hc/custom-attributes',
  dashboard_apps: '#hc/dashboard-apps',
  help_center: '#hc/help-center',
  inboxes: '#hc/inboxes',
  integrations: '#hc/integrations',
  labels: '#hc/labels',
  macros: '#hc/macros',
  reports: '#hc/reports',
  sla: '#hc/sla',
  team_management: '#hc/teams',
  webhook: '#hc/webhooks',
  billing: '#pricing',
  saml: '#hc/saml',
  captain: '#captain-docs',
  captain_billing: '#hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
